import { variant } from 'styled-system';
const appearances = variant({
  prop: 'variant',
  scale: 'typography.variants'
});
const fontStyles = variant({
  prop: 'fontStyle',
  scale: 'typography.fontStyle'
});
const variants = {
  appearances,
  fontStyles
};
export { variants };